import getCombatantById from "./getCombatantById";
import getCombatantSlots from "./getCombatantSlots";
//-----------------------------------------
// has pending slots for counters
//-----------------------------------------
// prevent gaps adding new counters where:
// a) counters exist
// b) no counters exist
//-----------------------------------------
export default async function hasPendingSlotsForCounters(parm) {
  console.log("---------------------------");
  console.log("hasPendingSlotsForCounters...");
  let pending = false;
  //---------------
  // get combatant
  //---------------
  let c = getCombatantById(parm.id);

  return new Promise((resolve, reject) => {
    //---------------------
    // get combatant slots
    //---------------------
    let call = getCombatantSlots(c.slug);
    call
      .then((slots) => {
        console.log("back from getCombatantSlots...");
        //-------------------------------
        // get rounds with pending slots
        //-------------------------------
        let pendingSlots = slots.markers.filter((a) => {
          return (
            a.action_count < parm.ca && // pending actions
            a.round >= parm.arena_round // ignore previous rounds
          );
        });
        console.log("pendingSlots = " + pendingSlots.length);
        for (let i = 0; i < pendingSlots.length; i++) {
          console.log("----------------------------");
          console.log("i = " + i);
          console.log("action_count = " + pendingSlots[i].action_count);
          console.log("ca = " + parm.ca);

          if (pendingSlots[i].action_count < parm.ca) {
            console.log("*** less than found... ");
            console.log("round = " + pendingSlots[i].round);
            console.log("num = " + pendingSlots[i].number);
          }
        }
        console.log("view round = " + parm.view_round);
        //-----------------------------------------------
        // A. where pending slots exist - get last round
        //-----------------------------------------------
        if (pendingSlots.length > 0) {
          let last_pending = pendingSlots[pendingSlots.length - 1];
          console.log("LAST ROUND = " + last_pending.round);
          //---------------------------------------------
          // if last round < this round = pending exists
          //---------------------------------------------
          if (last_pending.round < parm.view_round) {
            // console.log("xxx < than = true");
            pending = true;
            //------------------------
            // else no pending exists
            //------------------------
          } else {
            // console.log("xxx false");
            pending = false;
          }
          //
          //-------------------------------------------------------------------
          // B. if no markers at all + this round > cur round - pending exists
          //-------------------------------------------------------------------
        // } else if (slots.markers == 0 && parm.view_round > parm.arena_round) {
        //   console.log("yyy true");
        //   pending = true;
          //------------------------
          // else no pending exists
          //------------------------
        } else {
          // console.log("zzz false");
          pending = false;
        }
        //-------------
        // return flag
        //-------------
        resolve(pending);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
